import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Loading } from '@pandiafi/design-system'

import routePath from '../../router/routePath'
import { useAPILogout } from '../../api/apiHooks/useAPILogout'

export const LogoutView: React.FC = () => {
  const { state } = useLocation()
  const { mutate: logout, isPending, isSuccess } = useAPILogout()

  useEffect(() => {
    if (!isPending) {
      logout()
    }
  }, [isPending, logout])

  if (isSuccess) {
    return <Navigate to={routePath.login} state={state} replace />
  }

  return <Loading variant="details" />
}
